import { Skeleton } from '@mui/material';
import { useViewContext } from '../../../../lib/context/ViewContext';
import { HeadingLevel } from '../../../../lib/utils/HeadingMapper';
import { MappedAEMProperties } from '../../../../types';
import PureHeading from '../../../common/Heading/PureHeading';
import styles from './VideoReferences.module.scss';
import { videoReferencesIds } from '../../../../lib/tests/testIds';

export type VideoReferencesProps = {
  heading: string;
} & MappedAEMProperties;

const ReferencesSkeleton = () => (
  <div data-testid={videoReferencesIds.skeleton}>
    <Skeleton />
    <Skeleton />
    <Skeleton />
  </div>
);

const VideoReferences = ({ heading }: VideoReferencesProps) => {
  const { page, isLoading } = useViewContext();
  const { video } = page;
  const headingId = `video-section-${heading}`;

  if (!video?.videoId && !isLoading) {
    return null;
  }

  return (
    <div className={styles.sectionWrapper} data-testid={videoReferencesIds.container}>
      <div className={styles.sectionGrid}>
        <PureHeading id={headingId} level={HeadingLevel.h2} as={HeadingLevel.h3} className={styles.leftSubsection}>
          {heading}
        </PureHeading>
        <section aria-labelledby={headingId} className={styles.rightSubsection}>
          {isLoading ? <ReferencesSkeleton /> : <p className={styles.references}>{video?.description}</p>}
        </section>
      </div>
    </div>
  );
};

export default VideoReferences;
